import { Map as iMap, fromJS } from 'immutable';
const initialState = iMap({});

export function companyProduct(state = initialState, action) {
  switch (action.type) {
    case 'GET_PRODUCT_PROFILE':
      return state.set(action.payload.id, fromJS(action.payload));
    case 'CLEAR_STORES':
      return initialState;
    case 'RESEND_INVITATION_PF':
    case 'FAKE_RESEND':
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo', 'lastSent'], 'a few seconds ago');
      return state;
    case 'SEND_INVITATION_PF':
      const connectionInfo = action.payload;
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo'], connectionInfo);
      return state;
    case 'IGNORE_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo', 'status'], 'rejected');
      return state;
    case 'ACCEPT_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo', 'status'], 'accepted');
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/company/product/product-reducer.js